<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newDepartment')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'departments' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createDepartment" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <department-details-card ref="departmentDetailsCard"
                                   v-bind:department="department" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import DepartmentDetailsCard from '@/components/DepartmentDetailsCard.vue'

  export default {
    components: {
      DepartmentDetailsCard,
      HeaderButton,
      TopHeader
    },
    data: () => ({
      loading: false,
      department: {},
      validationSnackbar: false
    }),
    async created() {
      await this.loadTrainees()
    },
    methods: {
      async createDepartment() {
        if (!this.$refs.departmentDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateDepartment({ department: this.department })

        this.$router.push({ name: 'departments' })
      },
      ...mapActions({
        doCreateDepartment: 'common/createDepartment',
        loadTrainees: 'learning/loadTrainees'
      })
    },
    name: 'DepartmentAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newDepartment": "Neue Abteilung",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newDepartment": "New department",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>